import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type NodeLabelsProps } from '@process-advisor/process-miner/api/methods/settings/changeNodeLabels';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const NodeLabels = () => {
    const [NodeLabels, setNodeLabels] = React.useState<NodeLabelsProps>({});
    const onChange = _.curry((
        key: keyof NodeLabelsProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newNodeLabels = { ...NodeLabels, [key]: e.target.checked };
        setNodeLabels(newNodeLabels);
        apiProvider.changeNodeLabels(newNodeLabels);
        apiProvider.rebuildPVDiagram({});
    });

    React.useEffect(() => {
        setNodeLabels(apiProvider.getNodeLabels());
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setNodeLabels(apiProvider.getNodeLabels());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    const label = '# ' + apiProvider.getEntityLower() + 's'

    return (
        <Wrapper>
            <Checkbox
                label={label}
                checked={!!NodeLabels.tasks}
                handleOnChange={onChange('tasks')} />
            <Checkbox
                label='% total'
                checked={!!NodeLabels.perc_total}
                handleOnChange={onChange('perc_total')} />
        </Wrapper>
    );
};
